import { render, staticRenderFns } from "./ocrUpdOtherModify.vue?vue&type=template&id=2fb28a2e"
import script from "./ocrUpdOtherModify.vue?vue&type=script&lang=js"
export * from "./ocrUpdOtherModify.vue?vue&type=script&lang=js"
import style0 from "./ocrUpdOtherModify.vue?vue&type=style&index=0&id=2fb28a2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports